export function stripBase64(string) {
  return string.slice(string.indexOf(',') + 1);
}
